import { lazy, Suspense, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { APIServices } from "../../hooks/fetchAPI";
import { useNavigate, useParams } from "react-router";
import { pageRoutes } from "../../routes/pageRoutes";
import { storeUserDetails } from "../../redux/userSlice";
const UserForm = lazy(() => import("./UserForm"));
const Sidebar = lazy(() => import("../../component/Sidebar/Sidebar"));
const Dashboard = lazy(() => import("./Dashboard"));
const AfterExam = lazy(() => import("./Modal/AfterExam"));
const Faq = lazy(() => import("./Faq"));
const UserProfile = lazy(() => import("./UserProfile"));
const RatingModal = lazy(() => import("./Modal/RatingModal"));
const ResumeExam = lazy(() => import("./Modal/ResumeExam"));
const DataPrivacyModal = lazy(() => import("./Modal/DataPrivacyModal"));
const PrehiringEvaluation = lazy(() => import("./Modal/PrehiringEvaluation"));

const Applicant = () => {

    const { tab } = useParams();
    const dispatch = useDispatch();
    const [modalVisible, setModalVisible] = useState(localStorage.getItem("examCompleted") === "true");
    const [userResult, setUserResult] = useState(null);
    const [modalResume, setModalResume] = useState(false);
    const [showDataPrivacyModal, setShowDataPrivacyModal] = useState(false);
    const [completedExamType, setCompletedExamType] = useState([]);
    const [modalPrehiringEvaluation, setModalPrehiringEvaluation] = useState();
    const [preHiring, setPreHiringStatus] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [personalityStatus, setPersonalityStatus] = useState([]);
    const [onewayInterview, setOnewayInterview] = useState([]);
    const [qualificationStatus, setQualificationStatus] = useState([]);
    const [modalProfile, setModalProfile] = useState(false);
    const [modalRating, setModalRating] = useState(false);
    const [onBoardingId, setOnBoardingId] = useState(0);
    const [isOrientation, setOrientation] = useState(false);
    const navigate = useNavigate();
    const user = useSelector((state) => state.user.userData)

    const [error, setError] = useState(null);
    const videoRef = useRef(null);


    // useEffect(() => {
    //     if (parseInt(userResult?.user?.experience_set) === 6 && parseInt(qualificationStatus?.id) === 1) {
    //         statusUpdate(user?.id, 6, 'Applying for Admin Support – Maintenance & Security Position');
    //     }

    // }, [userResult, qualificationStatus?.id]);



    useEffect(() => {
        if (preHiring && (parseInt(userResult?.user?.experience_set) === 6 && parseInt(qualificationStatus?.id) === 1)) {
            statusUpdate(user?.id, 6, 'Applying for Admin Support – Maintenance & Security Position');
        }
    }, [userResult?.user?.experience_set, qualificationStatus?.id, preHiring]);

    useEffect(() => {

        let stream;
        const enableCameraAndMic = async () => {
            try {
                stream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        width: { ideal: 854 },
                        height: { ideal: 480 },
                        frameRate: { ideal: 30, max: 30 }
                    },
                    audio: true,
                });

                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                }
            } catch (err) {
                setError(`Error accessing camera or mic: ${err.message}`);
            }
        };

        enableCameraAndMic();

        return () => {
            if (stream) {
                stream.getTracks().forEach(track => track.stop());
            }
        };
    }, []);

    const getScore = async () => {
        try {
            const response = await APIServices.get({ url: `/onboarding/current-module/${user?.id}` });
            if (response && response.status === 200) {
                const currentModule = response?.data?.modules?.find(module => module.is_current);
                if (currentModule) {
                    setOnBoardingId(currentModule.module_id);
                }
            }
        } catch (error) {
            console.error('Error fetching module list:', error);
        }
    }


    const statusOnewayInterview = async () => {
        try {
            const response = await APIServices.get({ url: `/video-assessment/user-answers`, payload: { quality: '360' } });
            if (response && response.status === 200) {
                setOnewayInterview(response?.data || []);

            }
        } catch (error) {
            console.error("Error fetching video assessment questions:", error);
        }
    }

    const statusPersonality = async () => {
        try {
            const response = await APIServices.get({ url: `/person-exam/fetch-person-exam-status`, payload: { user_id: user?.id } });

            if (response && response.status === 200) {
                // setPersonalityStatus(response?.data?.data.filter(section => section.completed === false))
                setPersonalityStatus(
                    response?.data?.data?.filter(
                        section => !(section.completed || section.answered_count >= 6)
                    )
                );

            }
        } catch (error) {
            console.error("Error logging exam time:", error);
        }
    }

    const statusUpdate = async (id, qualification_id, remarks) => {
        try {
            const response = await APIServices.post({ url: `/create-qualification-status`, payload: { user_id: id, qualification_id: qualification_id, remarks: remarks } });
            if (response && response.status === 200) {
                console.log('Status Updated Successfully');
            }
        } catch (error) {
            console.error('Error fetching module list:', error);
        }
    }

    const moduleStatus = async () => {
        try {
            const response = await APIServices.get({ url: `/onboarding/current-module/${user?.id}` });
            if (response && response.status === 200) {
                const currentModule = response?.data?.modules?.find(module => module.is_current);
                if (currentModule) {
                    setOnBoardingId(currentModule.module_id);
                }
            }
        } catch (error) {
            console.error('Error fetching module list:', error);
        }
    };


    const resultAPI = async () => {
        setIsLoading(true);

        try {
            const response = await APIServices.get({ url: `/scoring/${user?.id}` });
            if (response && response.status === 200) {
                setUserResult(response?.data ?? []);

                const completedSectionIds = userResult?.scores
                    ?.filter(section => section.status === "completed" || section.status === "no max raw score")
                    .map(section => section.reference_order);

                setCompletedExamType(completedSectionIds)

                let exam_resume_id = null;
                // Find the lowest incomplete section within the 1-8 range
                for (let i = 1; i <= 8; i++) {
                    const section = response.data?.scores?.find(
                        s => s.reference_order === i && s.status !== "completed" && s.status !== "no max raw score"
                    );
                    if (section) {
                        exam_resume_id = i;
                        break; // Found the lowest incomplete section from 1-8
                    }
                }

                dispatch(storeUserDetails({
                    ...user,
                    exam_attempts: response.data?.user?.exam_attempts,
                    exam_resume_id: exam_resume_id,
                    completedSectionIds: completedSectionIds,
                    exam_status: response.data?.user?.status,
                    experience_set: response.data?.user?.experience_set,
                }))

            } else {
                console.error("Failed to fetch exam types:", response);
            }
        } catch (error) {
            console.error("Error fetching exam types:", error);
        } finally {
            setIsLoading(false);
        }

    }

    const resumeExam = async () => {
        try {

            const response = await APIServices.post({ url: `/mcq-user/re-attempt`, payload: { user_id: user?.id } });


            if (response && response.status === 200) {
                navigate(`/assessment/exam/${user?.exam_resume_id || 1}`);
            }
        }
        catch (error) {
            console.error("Error resuming exam:", error);
        }
    }

    const preHiringStatus = async () => {
        try {
            const response = await APIServices.get({ url: `/informal/answered` });

            if (response && response.status === 200) {
                setPreHiringStatus(response?.data?.has_completed)
            }
        }
        catch (error) {
            console.error("Error resuming exam:", error);
        }
    }

    const getQualificationStatus = async () => {
        try {
            const response = await APIServices.get({ url: `/get-qualification-status`, payload: { user_id: user?.id } });

            if (response && response.status === 200) {
                setQualificationStatus(response?.data?.current_status?.qualification || "No Status")
            }
        }
        catch (error) {
            console.error("Error resuming exam:", error);
        }
    }


    const onConsent = async () => {
        if (!preHiring && (parseInt(userResult?.user?.experience_set) !== 6 && parseInt(qualificationStatus?.id) === 1)) {
            setShowDataPrivacyModal(false);
            setModalPrehiringEvaluation(true);
        } else {
            setShowDataPrivacyModal(false);
            navigate('/applicant/');
        }
    }

    useEffect(() => {
        if (userResult?.user?.status !== 'completed' && userResult?.user?.remaining_attempts !== 0) {
            if (userResult?.scores?.some(section => section.status === "incomplete")) {
                setModalResume(true);
            }
        }
    }, [userResult]);

    useEffect(() => {
        const loadSequence = async () => {
            try {
                getScore();
                getQualificationStatus();
                setIsFetching(true);
                moduleStatus();
                await preHiringStatus();
                await resultAPI();
                await statusPersonality();
                await statusOnewayInterview();
            }
            catch (error) {
                console.error("Error loading sequence:", error);
            } finally {
                setIsFetching(false);
            }
        }
        loadSequence();
    }, [user?.id, tab, modalPrehiringEvaluation, userResult?.user?.status]);

    useEffect(() => {
        if (tab === "data-privacy") {
            setShowDataPrivacyModal(true);
        } else if (tab === "done-onboarding") {
            setOrientation(true);
        }
    }, [tab]);



    useEffect(() => {
        if (userResult?.user?.experience_set !== 6 && preHiring && tab !== "close-exam" && !isFetching && (qualificationStatus?.id !== 14)) {
            if (userResult?.date_started === null) {
                navigate(`/assessment/exam/${userResult?.exam_type_to_answer || 1}`);
                return; // Stop further navigations
            }

            // if (completedExamType?.length === 8 && personalityStatus.length !== 0) {
            //     navigate(`/personality-exam/${statusPersonality?.[0]?.id || 1}`);
            //     return;
            // }

            // if (completedExamType?.length === 8 && personalityStatus.length === 0 && parseInt(onewayInterview?.answered_count) !== parseInt(onewayInterview?.total_questions)) {
            //     navigate(pageRoutes.VIDEOINTERVIEW);
            //     return;
            // }


        } else if (qualificationStatus?.id === 14 && tab !== "close-exam" && tab !== "data-privacy" && onBoardingId !== 0) {
            if (qualificationStatus?.id === 14) {
                navigate(`/onboarding-exam/${onBoardingId || 1}`);
                return;
            }
        } else {
            return;
        }

        if (tab === "application-form") {
            navigate(pageRoutes.USERFORM);
        }
    }, [preHiring, tab, userResult, completedExamType, personalityStatus, onewayInterview, isFetching, qualificationStatus, onBoardingId]);

    useEffect(() => {
        if (localStorage.getItem("examCompleted") === "true") {
            setModalVisible(true);
            localStorage.setItem("examCompleted", "false");
        } else {
            setModalVisible(false);
            localStorage.setItem("examCompleted", "false");
        }

    }, []);

    let content;
    switch (tab) {
        case "application-form":
            content = <UserForm />;
            break;
        case "faq":
            content = <Faq />;
            break;
        default:
            content = <Dashboard isAdminSupport={userResult?.user?.experience_set === 6} userResult={userResult} onBoardingId={onBoardingId} user={user} qualificationStatus={qualificationStatus} isFetching={isFetching} isLoading={isLoading} examData={userResult} preHiringStatus={preHiring} setPreHiringStatus={setModalPrehiringEvaluation} resumeExam={resumeExam} personalityStatus={personalityStatus} onewayInterview={onewayInterview} />;
    }

    return (
        <div className="h-screen flex flex-row w-full overscroll-none bg-gray-100">
            <Suspense fallback={<div></div>}>
                {modalProfile && <UserProfile visible={modalProfile} onClose={() => setModalProfile(false)} />}
                {modalPrehiringEvaluation && <PrehiringEvaluation visible={modalPrehiringEvaluation} onClose={() => setModalPrehiringEvaluation(false)} />}
                {modalVisible && <AfterExam visible={modalVisible} onClose={() => { setModalVisible(false); setModalRating(!isOrientation); }} />}
                {showDataPrivacyModal && <DataPrivacyModal visible={showDataPrivacyModal} onClose={() => setShowDataPrivacyModal(false)} onConsent={onConsent} />}
                {modalResume && <ResumeExam visible={modalResume} onClose={() => { setModalResume(false); }} handleResume={resumeExam} />}
                {modalRating && <RatingModal visible={modalRating} onClose={() => setModalRating(false)} />}
            </Suspense>

            <Suspense fallback={<div></div>}>
                <Sidebar activeTab={tab} onProfileClick={() => setModalProfile(true)} />
                {content}

                {/* <button className="fixed bottom-4 right-4 bg-blue-500 text-white px-4 py-2 rounded" onClick={() => statusUpdate(user?.id, 15, 'Testing')}>update rating</button> */}
            </Suspense>
        </div>
    );
}

export default Applicant;